import React from 'react';
import { Slider } from '../../../components/Slider';
import { TabProps } from './shared';

export const StatsTab: React.FC<TabProps> = ({ ability, update }) => (
  <>
    <Slider label="Mana Cost" value={ability.manaCost ?? 0} min={0} max={100} step={1}
      onChange={v => update({ manaCost: v })} />
    <Slider label="Cooldown (ms)" value={ability.cooldown ?? 0} min={0} max={60000} step={100}
      formatValue={v => v > 0 ? `${v}ms` : 'None'} onChange={v => update({ cooldown: v })} />
    <Slider label="Cast Time (ms)" value={ability.castTime ?? 0} min={0} max={5000} step={50}
      formatValue={v => v > 0 ? `${v}ms` : 'Instant'} onChange={v => update({ castTime: v })} />
  </>
);
